module.exports = __webpack_public_path__ + "img/source03_m1.2e397a61.png";